import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconDownload({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M.5 14a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0V13h14V8.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.41.492L15.5 14H.5zM8 0a.5.5 0 0 1 .5.5v8.874l2.654-2.542a.51.51 0 0 1 .7 0 .46.46 0 0 1 0 .671L8.35 10.861a.51.51 0 0 1-.7 0L4.145 7.503a.46.46 0 0 1 0-.671.511.511 0 0 1 .701 0L7.5 9.374V.5A.5.5 0 0 1 8 0z"/>
        </svg>
    );
}

export default IconDownload;
